import { allLanguages, defaultLanguage, Locale } from "../../globals"


export let getLangFromDocument = () => {
  
  let lang =  document.documentElement.lang;
  if(lang == defaultLanguage) return "";
  return lang;
}

export const getLangFromUrl: () => Locale = () => {
    let lang: Locale = defaultLanguage
    if (window.location.pathname != '/') {
      const pathSplit = window.location.pathname.split('/')
      if (pathSplit.length > 1) {
        lang = pathSplit[1] as Locale
      }
    }
    return allLanguages.includes(lang) ? lang : defaultLanguage
  }
  
  //example of url: en/xyz
  //not good url: /en/xyz
  export const removeLangFromUrl = (url: string) => {
    let url1 = url
    if (url != '/' && url != "") {
      const pathSplit = url.split('/')
      if (pathSplit.length > 1) {
        if(pathSplit[0] == "wp"){
          pathSplit[0] = ""
          if(pathSplit[1] == getLangFromDocument()){
            pathSplit[1] = ""
          }
        }
        else{
          if(pathSplit[0] == getLangFromDocument()){
            pathSplit[0] = ""
          }
        }
        url1 = pathSplit.filter(a => a != "").join('/')
      }
    }
    return url1
  }